module.exports = __webpack_public_path__ + "static/img/ls30.87e3d38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls30.png
// module id = CVg0
// module chunks = 12